import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { initPostHog, identifyUser, resetUser } from '../lib/analytics';

export function AnalyticsManager() {
  const { isSignedIn, isLoaded, user } = useAuth();
  const isSignedInRef = useRef(isSignedIn);
  const userRef = useRef(user);
  isSignedInRef.current = isSignedIn;
  userRef.current = user;

  // Init PostHog on consent grant (handles both pre-existing consent and new grants)
  useEffect(() => {
    const tryIdentify = () => {
      const u = userRef.current;
      if (isSignedInRef.current && u) {
        identifyUser(u.id, { email: u.email, name: u.name });
      }
    };

    const handleConsent = () => {
      initPostHog();
      tryIdentify();
    };

    if ((window as any).__analyticsConsented) {
      handleConsent();
    }

    document.addEventListener('analytics-consent-granted', handleConsent);
    return () => document.removeEventListener('analytics-consent-granted', handleConsent);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Identify / reset when auth state changes (after PostHog is initialised)
  useEffect(() => {
    if (!isLoaded) return;
    if (isSignedIn && user) {
      identifyUser(user.id, { email: user.email, name: user.name });
    } else {
      resetUser();
    }
  }, [isSignedIn, isLoaded, user]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}
